/**
 * <ImpersonatePage> — l'ouverture d'une session impersonnée, depuis « Impersonner » du back-office
 * (page).
 *
 * L'admin n'a rien à saisir : le lien porte un code à usage unique, la page dit où en est
 * l'échange. Trois états, que le câblage choisit — `connecting`, `invalid` (pas de code),
 * `expired` (code refusé). La forme est celle de `<LoginLinkPage>`, l'écran du lien « Me
 * connecter » : même coquille, même attente en mots.
 *
 * Pas de retour : on arrive ici depuis un nouvel onglet ouvert par le back-office.
 */
import React from "react"

import { type UIImpersonateStatus } from "../../../ports/primary/ui/types"
import { WaitingText } from "../../atoms/WaitingText"
import { AuthHeading } from "../../molecules/AuthHeading"
import { AuthTemplate } from "../../templates/AuthTemplate"

const CONNECTING = "Connexion en cours…"
const RETRY = "Relancez « Impersonner » depuis la fiche du back-office."
const TITLES: Record<Exclude<UIImpersonateStatus, "connecting">, string> = {
    invalid: "Lien d'impersonation invalide",
    expired: "Ce lien a expiré",
}

export type ImpersonatePageProps = {
    status: UIImpersonateStatus
    testID?: string
}

export function ImpersonatePage(props: ImpersonatePageProps) {
    const { status, testID } = props

    return (
        <AuthTemplate centered testID={testID}>
            {status === "connecting" ? (
                <WaitingText>{CONNECTING}</WaitingText>
            ) : (
                <AuthHeading title={TITLES[status]}>{RETRY}</AuthHeading>
            )}
        </AuthTemplate>
    )
}
